"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function debug() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (Rollbar) {
        Rollbar.debug.apply(Rollbar, args);
    }
}
exports.debug = debug;
function error() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (Rollbar) {
        Rollbar.error.apply(Rollbar, args);
    }
}
exports.error = error;
